function isSafeInternalPath(value) {
  return (
    typeof value === 'string' &&
    value.startsWith('/') &&
    !value.startsWith('//')
  );
}

export function getSafeRedirectTarget(rawValue, fallback = '/account') {
  return isSafeInternalPath(rawValue) ? rawValue : fallback;
}

export function buildAuthHref(pathname, redirectTarget) {
  const params = new URLSearchParams();

  if (isSafeInternalPath(redirectTarget)) {
    params.set('redirect', redirectTarget);
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
